import { useFormik } from "formik";
import { Button, Grid, TextField } from "src/components";
import VwHbsHastaliktanimDTO from "src/models/HastalikTanim/VwHbsHastaliktanimDTO";
import { useAppDispatch, useAppSelector } from "src/store";
import * as yup from "yup";
import { translate } from 'src/i18n/tHelper';
import HastalikTanimSlice from "src/store/Slices/GenelTanimlar/HastalikTanimSlice";
import { useHastalikTanimEkleMutation, useHastalikTanimGuncelleMutation } from "src/services/HastalikTanim/HastalikTanimApi";

interface IHastalikFormProps { };
const path = 'pages|hataliktanim';
const HastalikForm = (props: IHastalikFormProps): JSX.Element => {
    const hastalikTanimActiveRow = useAppSelector(s=> s.hastalikTanim.hastalikTanimActiveRow);
    const [ekle, ekleState] = useHastalikTanimEkleMutation();
    const [guncelle, guncelleState] = useHastalikTanimGuncelleMutation();
    const dispatch = useAppDispatch();

    const formik = useFormik({
        initialValues: hastalikTanimActiveRow.id ? hastalikTanimActiveRow : new VwHbsHastaliktanimDTO(),
        onSubmit: (values) => {
            if(values.id)
            {
                guncelle({
                    adi: values.adi,
                    id: values.id
                }).unwrap()
                .then(closeHandler)
                .catch(err => err)
            }
            else
            {
                ekle(values)
                .unwrap()
                .then((val) => {
                    dispatch(HastalikTanimSlice.actions.setHastalikTanimActiveRow(val));
                    closeHandler()
                })
                .catch(err => err)
            }
        },
        validationSchema: yup.object({
            adi: yup.string().required(translate(path, "Zorunlu Alan"))
        }),
    })

    const closeHandler = () => {
        dispatch(HastalikTanimSlice.actions.setFetchParam(1));
        dispatch(HastalikTanimSlice.actions.setDialogParam(0));
    }

    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <TextField 
                        name="adi"
                        label={translate(path,"Adı")}
                        value={formik.values.adi}
                        onChange={formik.handleChange}
                        // helperText={formik.errors.adi}
                        error={formik.errors.adi?.length > 0}                        
                    />
                </Grid>
                <Grid item md={6}>
                    <Button 
                        customType="save"
                        onClick={() => formik.submitForm()}
                        loading={ekleState.isLoading || guncelleState.isLoading}
                    />
                </Grid>                
                <Grid item md={6}>
                    <Button 
                        customType="cancel"
                        onClick={() => closeHandler()}
                    />
                </Grid>                
            </Grid>
        </>
    );
};

export default HastalikForm;